import React, { useCallback, useMemo } from "react";
import { observer } from "mobx-react-lite";

import DownloadButton from "../../../../../components/buttons/download-button/DownloadButton";
import { permissionsService } from "../../../../../services/authorization/UserPermissionsService";
import { ReportTemplatesStorage } from "../../../../../services/organization/ReportTemplatesStorage";
import { ManageReportTemplates } from "../../../../../services/authorization/Permissions";
import { ButtonProps } from "../../../../../components/button/Button";

interface DownloadReportTemplateButtonProps extends ButtonProps {
  reportTemplatesStorage: ReportTemplatesStorage;
}

export const DownloadReportTemplateButton = observer((props: DownloadReportTemplateButtonProps) => {
  const { reportTemplatesStorage } = { ...props };

  const isDisabled = useMemo(
    () =>
      !reportTemplatesStorage.anyItemsSelected ||
      !permissionsService.userHasPermissionTo(ManageReportTemplates),
    [reportTemplatesStorage.anyItemsSelected]
  );

  const handleDownloadReportTemplates = useCallback(async () => {
    await reportTemplatesStorage.downloadReportTemplates();
  }, [reportTemplatesStorage]);

  return <DownloadButton disabled={isDisabled} onClick={handleDownloadReportTemplates} />;
});
